import assign from 'lodash/assign';
import clone from 'lodash/clone';

const cdnBasePaths = {
    dev: 'https://mwc-cdn-qa.morningstar.com/',
    qa: 'https://mwc-cdn-qa.morningstar.com/',
    uat: 'https://mwc-cdn-uat.morningstar.com/',
    prod: 'https://mwc-cdn.morningstar.com/',
};

const awsApiGatewayDefault = {
    dev: 'http://localhost/v',
    qa: 'https://www.us-qa-api.morningstar.com/EC-config/v',
    stg: 'https://www.us-stg-api.morningstar.com/EC-config/v',
    uat: 'https://www.us-uat-api.morningstar.com/EC-config/v',
    prod: 'https://www.us-api.morningstar.com/EC-config/v',
};

const awsApiGatewayRegionOverrides = {
    apac: {
        uat: 'https://www.apac-uat-api.morningstar.com/EC-config/v',
        prod: 'https://www.apac-api.morningstar.com/EC-config/v',
    },
    emea: {
        uat: 'https://www.emea-uat-api.morningstar.com/EC-config/v',
        prod: 'https://www.emea-api.morningstar.com/EC-config/v',
    },
};

const awsApiGatewayServicePath = '/configurationfiles';

/**
 * Returns the base path for the component CDN for the given environment
 * @param  {string} environment - component CDN environment, e.g. prod
 * @returns {string} - base path for the component CDN
 */
function getCdnBasePath(environment) {
    const basePath = cdnBasePaths[environment];
    if (!basePath) {
        throw new Error(`Specified CDN environment '${environment}' does not exist.`);
    }
    return basePath;
}

/**
 * Returns the base path for the config API
 * @param  {string} environment - config source environment, e.g. prod
 * @returns {string} - base path for the config API
 */
function getConfigApiBasePath(environment, version, region) {
    let returnPath;

    const awsApiGatewayMerged = clone(awsApiGatewayDefault);

    if (Object.prototype.hasOwnProperty.call(awsApiGatewayRegionOverrides, region)) {
        assign(awsApiGatewayMerged, awsApiGatewayRegionOverrides[region]);
    }

    if (Object.prototype.hasOwnProperty.call(awsApiGatewayMerged, environment)) {
        returnPath = awsApiGatewayMerged[environment];
    } else {
        throw new Error(`Specified config source environment '${environment}' does not exist.`);
    }

    return `${returnPath}${version}${awsApiGatewayServicePath}`;
}

export {
    getCdnBasePath,
    getConfigApiBasePath,
};



// WEBPACK FOOTER //
// ../loader-base/src/services/paths.js